/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-empty-function */
// @ts-nocheck
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import DatePicker from 'react-datepicker';
import { Field, useFormikContext } from 'formik';
import styles from './FormFields.module.scss';
import dayjs from 'dayjs';

const DATE_FORMAT = 'YYYY-MM-DD';
const DATE_TIME_FORMAT = 'YYYY-MM-DD h:mm a';

const CustomDatePickerInput = React.forwardRef(
  ({ onClick, value, ...props }, ref) => (
    <input
      type="text"
      onClick={onClick}
      value={value}
      ref={ref}
      {...props}
      data-cy="datepicker"
    />
  )
);

const DayPickerField = ({
  name,
  disabledBefore,
  disabledAfter,
  className,
  placeholderText,
  onChange = () => {},
  ...props
}) => {
  const { setFieldValue, values, validate } = useFormikContext();
  const currentValue = values[name];
  const currentTimeValue = values[`${name}Time`];
  const selectedDay = currentValue ? new Date(currentValue) : undefined;

  const handleChange = (value) => {
    if (!value) {
      setFieldValue(name, null);
    }

    const day = dayjs(value).format(DATE_FORMAT);
    const format = currentTimeValue ? DATE_TIME_FORMAT : DATE_FORMAT;
    const combined = dayjs(`${day} ${currentTimeValue || ''}`, format);

    if (combined.isValid()) {
      setFieldValue(name, combined.toDate());

      if (onChange) {
        onChange();
      }
    }
  };

  return (
    <Field name={name} validate={validate}>
      {({ meta }) => (
        <>
          <DatePicker
            className={cn(className || styles.DayPickerField, {
              [styles.datepickerError]: meta.error && meta.touched
            })}
            customInput={
              <CustomDatePickerInput
                className={styles.datePickerInput}
                data-cy="datepicker"
              />
            }
            selected={selectedDay}
            onChange={handleChange}
            minDate={disabledBefore}
            maxDate={disabledAfter}
            dateFormat="yyyy-MM-dd"
            placeholderText={placeholderText}
            showMonthDropdown
            showYearDropdown
            dropdownMode="select"
            disabled={props.disabled}
            {...props}
          />
          {/* {meta.error && meta.touched && ( */}
          {/*  <div className={styles.datepickerErrorMessage}>{meta.error}</div> */}
          {/* )} */}
        </>
      )}
    </Field>
  );
};

DayPickerField.propTypes = {
  name: PropTypes.string.isRequired,
  disabledBefore: PropTypes.instanceOf(Date),
  disabledAfter: PropTypes.instanceOf(Date),
  className: PropTypes.string,
  placeholderText: PropTypes.string
};

DayPickerField.defaultProps = {
  disabledBefore: undefined,
  disabledAfter: undefined,
  className: undefined
};

export default DayPickerField;
